[
    { "name": "bot-status" },
    { "name": "bot-volcurtemp" },
    { "name": "cm-sensors" },
    { "name": "cm-sensors-two" },
    { "name": "control-cabinet" },
    { "name": "conver-errors" },
    { "name": "conver-statistics" },
    { "name": "conver-status" },
    { "name": "current-voltage" },
    { "name": "distance" },
    { "name": "distance-vertical" },
    { "name": "electricity" },
    { "name": "energy-consuption" },
    { "name": "error-messages" },
    { "name": "fine-positioning" },
    { "name": "finger-movements" },
    { "name": "finger-time" },
    { "name": "fts-chassis" },
    { "name": "fts-chassis-km" },
    { "name": "fts-energy" },
    { "name": "fts-general" },
    { "name": "good-bad-reads" },
    { "name": "health-predictions" },
    { "name": "image" },
    { "name": "last-scan" },
    { "name": "lsc-scan-information" },
    { "name": "movements" },
    { "name": "orders" },
    { "name": "position" },
    { "name": "roll-in-out" },
    { "name": "scan-quality" },
    { "name": "ssagm-carrier-statistic" },
    { "name": "ssagm-stat-dtm" },
    { "name": "ssagm-stat-es" },
    { "name": "ssagm-stat-if" },
    { "name": "ssagm-statistic" },
    { "name": "ssagm-statistic-std" },
    { "name": "sscrr-cylinder" },
    { "name": "sscrr-statistic" },
    { "name": "ssdtm-clamping-chain" },
    { "name": "ssdtm-clamping-general" },
    { "name": "ssdtm-info" },
    { "name": "ssdtm-lubrication-cartridge" },
    { "name": "ssdtm-lubrication-general" },
    { "name": "sses-flaps" },
    { "name": "sses-statistics" },
    { "name": "ssif-belt" },
    { "name": "ssif-statistic" },
    { "name": "statistic" },
    { "name": "status" },
    { "name": "sum-of-power" },
    { "name": "temperature" },
    { "name": "temperature-current" },
    { "name": "testrun" },
    { "name": "testrun-calculated" },
    { "name": "testrun-status" },
    { "name": "time" }
]
